export const validateLogin = (empId, empPin, setIdError, setPinError) => {
  let isError = false;
  if (empId === "") {
    setIdError("Please enter employee ID");
    isError = true;
  }
  if (empPin === "") {
    setPinError("Please enter employee PIN");
    isError = true;
  } else if (isNaN(Number(empPin))) {
    setPinError("Please enter valid employee PIN");
    isError = true;
  } else if (empPin.length !== 4) {
    setPinError("Please enter 4digit employee PIN");
    isError = true;
  }
  return isError;
};
